import { Tipo_aprobacion } from './../../../models/tipo_aprobacion.model';
import { Component } from "@angular/core";


@Component({
    selector: "page-tipo_aprobacion",
    templateUrl: "./tipo_aprobacion.component.html"
    
})


export class tipo_aprobacionComponent {
    public rows = [];
    public actualRow;
    public tipo_aprobacion: Tipo_aprobacion;
    public form;
    public aprobacion = {"obra_nueva": false, "ampliacionmayor100m": false, "alteracion":false, "reconstruccion":false}
    constructor(){
        if(!JSON.parse(localStorage.getItem("tipo_aprobacion"))){
            localStorage.setItem("tipo_aprobacion", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("tipo_aprobacion"));
            this.aprobacion = { 
             "obra_nueva": this.rows[0] ? this.rows[0].aprobacion.obra_nueva : false,
             "ampliacionmayor100m": this.rows[0]? this.rows[0].aprobacion.ampliacionmayor100m : false,
             "alteracion": this.rows[0]? this.rows[0].aprobacion.alteracion : false,
              "reconstruccion": this.rows[0]? this.rows[0].aprobacion.reconstruccion : false
            }
        }
    }

    add_tipo_aprobacion(){
        localStorage.setItem("tipo_aprobacion",JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_aprobacion");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            aprobacion: this.aprobacion
            
          
        })
        localStorage.setItem("tipo_aprobacion", JSON.stringify(this.rows));
        console.log(JSON.parse(localStorage.getItem("tipo_aprobacion")));
    }
  
    delete_tipo_aprobacion(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_aprobacion", JSON.stringify(this.rows));
            }
        }
    }   
}